import { css } from 'styled-system/css';

export const voucherDropdownStyle = {
	tabWrapper: css({
		base: {
			display: 'flex',
			justifyContent: 'flex-start',
			w: '100%',
			fontSize: '12px',
			fontWeight: '700',
			maxW: 'none',
			minH: 'auto',
			p: '0 9px',
			borderRadius: '6px',
			h: '33px',
			lineHeight: '33px',
			gap: '3px',
			mt: '6px',
			color: 'black.2',
			position: 'relative',
		},
		_galaxy: {
			bgColor: 'var(--background-neutral-500-700)',
			_hover: {
				bgColor: 'var(--background-neutral-400-500-bg3)',
			},
			_focus: {
				bgColor: 'var(--background-neutral-500-700)',
			},
		},
		'& .voucher-used': {
			color: 'black.1',
		},
	}),
	tabIcon: css({
		base: {
			ml: 'auto',
			w: '16px',
			h: '16px'
		}
	}),
	promoTag: css({
		display: 'block',
		h: '13px',
		p: '0 3px 1px 3px',
		borderRadius: '3px 3px 3px 0',
		background: 'linear-gradient(270deg, #EB0000 0%, #FD693C 100%)',
		color: 'white',
		fontSize: '10px',
		fontWeight: '700',
		lineHeight: '12px',
		position: 'absolute',
		top: '-8.5px',
		left: '-4px',
		_before: {
			content: '""',
			w: '4px',
			h: '4.5px',
			bgColor: '#4C1419',
			position: 'absolute',
			bottom: '-4.5px',
			left: '0px',
			clipPath: 'ellipse(100% 70% at 100% 0%)',
		}
	}),

	disableStatus: css({
		// base: {

		// },
		// _mars : {
		backgroundColor: 'disableVoucher.bg',
		color: 'disableVoucher.text',
		'& .icon--gift': {
			color: 'disableVoucher.text',
		}
		// }		
	}),
}